import jsonata from 'jsonata';
import { Data, Condition } from '../model/rule-engine.model';
import { AbstractCondition } from './abstract-condition';

export class EqualityCondition<T> extends AbstractCondition<T> implements Condition<T> {
  readonly type = 'isEqualTo';
  params: Data;

  assert(context: T): boolean {
    return Object.entries(this.params).every(([targetAttribute, targetValue]) => {
      const sourceValue = jsonata(targetAttribute).evaluate(context);
      return sourceValue === targetValue;
    });
  }
}
